import { Injectable } from '@angular/core';
import { BehaviorSubject, delay } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DatabaseService {
  public $database = new BehaviorSubject<any>(null);

  constructor() {
    this.deleteDatabase('ibextouch')
      .then(console.log)
      .catch(console.error);
    if (!this.$database.getValue()) {
      const request = indexedDB.open('ibextouchV2', 1);
      request.onupgradeneeded = (event: any) => {
        let db = event.target.result;
        if (!db.objectStoreNames.contains('store')) {
          db.createObjectStore('store', { keyPath: null });
        }
      };

      request.onsuccess = (event: any) => {
        console.log("Database opened successfully");
        let db = event.target.result;
        this.$database.next(db);
      };

      request.onerror = (event: any) => {
        console.error("Database error: ", event.target.error);
      };
    }
  }

  public get(key): Promise<any> {
    return new Promise((resolve, reject) => {
      const dbSub = this.$database.pipe(delay(0)).subscribe(db => {
        if (db) {
          if (dbSub) {
            dbSub.unsubscribe();
          }
          let transaction = db.transaction('store', 'readonly');
          const store = transaction.objectStore('store');

          const request = store.get(key);
          request.onsuccess = () => {
            const data = request.result;
            if (!data) return resolve(null);
            if (data?.buffer instanceof ArrayBuffer) resolve(this.arrayBufferToBlob(data.buffer, data.type));
            resolve(request.result);
          };
          request.onerror = () => reject(request.error);
        }
      });
    });
  }

  public remove(key): Promise<any> {
    return new Promise((resolve, reject) => {
      const dbSub = this.$database.pipe(delay(0)).subscribe(db => {
        if (db) {
          if (dbSub) {
            dbSub.unsubscribe();
          }
          let transaction = db.transaction('store', 'readwrite');
          const store = transaction.objectStore('store');

          const request = store.delete(key);
          request.onsuccess = () => resolve('Data deleted');
          request.onerror = (event) => reject(event.target.error);
        }
      });
    });
  }

  public async put(key, value): Promise<any> {
    let buffer;
    if ((value instanceof Blob) && (value.size && value.size < 1900000000)) {
      buffer = await this.blobToArrayBuffer(value);
    }
    return new Promise((resolve, reject) => {
      const dbSub = this.$database.pipe(delay(0)).subscribe(db => {
        if (db) {
          if (dbSub) {
            dbSub.unsubscribe();
          }
          let transaction = db.transaction('store', 'readwrite');
          const store = transaction.objectStore('store');
          let request: any;
          if (buffer) {
            request = store.put({ buffer, type: value.type }, key);
          } else {
            request = store.put(value, key);
          }
          request.onsuccess = () => resolve(request.result);
          request.onerror = () => reject(request.error);
        }
      });
    });
  }

  public async blobToArrayBuffer(blob) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsArrayBuffer(blob);
    });
  }

  public arrayBufferToBlob(buffer, mimeType) {
    return new Blob([buffer], { type: mimeType });
  }

  deleteDatabase(dbName) {
    return new Promise((resolve, reject) => {
      const request = indexedDB.deleteDatabase(dbName);

      request.onsuccess = () => resolve(`Database "${dbName}" deleted successfully`);
      request.onerror = (event: any) => reject(`Error deleting database: ${event.target.error}`);
      request.onblocked = () => reject(`Database deletion blocked. Close all connections first.`);
    });
  }
}
